import "./modules.css";
import { nounUpload} from "helper/images";

export const Button = (props) => {
	const {
		label,
		onClick,
		width = "w-48",
		disabled = false,
		icon,
	} = props || {};


	const onNavigate = () => {
		onClick(true)
		
	};

	return (
		<div
			className={`h-11 ${width} bg-lightBlue hover:bg-purple-800 ${
				disabled ? "opacity-50" : ""
			} rounded-lg items-center justify-center flex`}
		>
		
				<button
					onClick={onNavigate}
					className={`${width} h-11 font-semibold text-base text-white flex flex-row justify-center items-center`}
					disabled={disabled}
				>
					{!!icon && <img src={icon} alt="" className="mr-2 w-5 h-5" />}
					{label} <img src={nounUpload} alt="upload" className="w-6 ml-2"/>
				</button>
		
		</div>
	);
};
